const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cbe831ca2345d742962d195cae2d42f420fdd6cb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["property-group@haunt"]={id:"cbe831ca2345d742962d195cae2d42f420fdd6cb"};
      